/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */


import { formatDate } from '../date';
import sanitize from 'sanitize-filename';

interface FilenameProps {
  initiativeName?: string;
  effectiveDate: string,
  _id: string,
  type?: string
}

export const getFilename = ({ initiativeName, effectiveDate, _id, type }: FilenameProps) => {

  const nameParts = [];
  if (initiativeName) {
    nameParts.push(initiativeName);
  }

  if (effectiveDate) {
    nameParts.push(
      formatDate(effectiveDate, 'YYYY MMMM', true)
    );
  }

  if (type) {
    nameParts.push(type)
  }

  // Fallback to id
  if (nameParts.length === 0) {
    nameParts.push('(' + String(_id) + ')');
  }

  return sanitize(nameParts.join(' '));
};
